import React from "react";
import { ProductGroup, formatPrice, getSizeLabel } from "../utils/productGroups";
import { ProductImage } from "./ProductImage";
import { QuantityControl } from "./QuantityControl";
type ProductGroupDetailProps = {
  group: ProductGroup;
  backLabel: string;
  onBack: () => void;
};
export function ProductGroupDetail({
  group,
  backLabel,
  onBack
}: ProductGroupDetailProps) {
  const lead = group.products.find(product => product.imageUrl) ?? group.products[0];
  const description = group.products.find(product => product.description)?.description;
  return <div data-id="element-227" data-mp="2crs3s7dpkmdn">
      <button type="button" onClick={onBack} className="mb-8 text-sm font-medium text-[#35dceb] underline decoration-transparent underline-offset-4 transition-colors duration-150 ease-out hover:decoration-current focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#35dceb]" data-id="element-228" data-mp="1yumxq7dzvnie">
        {backLabel}
      </button>

      <div className="grid gap-8 md:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] md:gap-12" data-id="element-229" data-mp="ntw26ybi4owa">
        <div className="border border-[#ff3aa2]/35 bg-[#1b0b1a] p-3 md:self-start" data-id="element-230" data-mp="nrj9pr84aw4z">
          <ProductImage product={lead} alt={group.name} data-id="element-231" data-mp="js2673c9492g" />
        </div>

        <div data-id="element-232" data-mp="xidxx14xc5t2">
          <header className="border-b border-[#ff3aa2]/60 pb-6" data-id="element-233" data-mp="xj74o23vuvb7">
            <h1 className="text-3xl font-semibold tracking-tight text-[#ff5bad] sm:text-4xl" data-id="element-234" data-mp="skcg0jj8icj6">{group.name}</h1>
            {description && <p className="mt-3 text-sm leading-6 text-white/75" data-id="element-235" data-mp="4vjqp5x4b2xj">{description}</p>}
          </header>

          <h2 className="mt-8 text-lg font-semibold text-[#35dceb]" data-id="element-236" data-mp="v0y39nehsua">Choose your size</h2>
          <ul className="mt-4 divide-y divide-white/10 border-y border-white/10" data-id="element-237" data-mp="eu0jm8fm9rm8">
            {group.products.map(product => {
            const size = group.labels[product.variationId] ?? getSizeLabel(product);
            return <li key={product.variationId} className="grid grid-cols-1 gap-4 py-5 sm:grid-cols-[minmax(0,1fr)_auto] sm:items-center" data-id="element-238" data-mp="1qa7b0jposb61">
                  <div data-id="element-239" data-mp="1tar35bztpejb">
                    <p className="text-lg font-semibold text-white" data-id="element-240" data-mp="1t9fv2zzchkme">{size}</p>
                    <p className="mt-1 text-base font-semibold text-[#ff5bad]" data-id="element-241" data-mp="1xajchqx1jopq">{formatPrice(product.priceCents, product.currency)}</p>
                  </div>
                  <QuantityControl product={product} label={`${group.name} ${size}`} data-id="element-242" data-mp="279qoa9o4nbaq" />
                </li>;
          })}
          </ul>
        </div>
      </div>
    </div>;
}